import {
  Alert,
  Container,
  LinearProgress,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";
import React from "react";
import BackBtn from "../../widgets/BackBtn";
import useApiEp from "../../hooks/useApiEp";
import { getErrorResponse } from "../../utils/util";

const MediaItems = () => {
  const { data, isLoading, isError, error } = useApiEp(`/root/all-media-list`);

  if (isLoading) {
    return <LinearProgress />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  const mediaList = data?.data || [];

  return (
    <Container sx={{ mt: 3 }}>
      {/* Header */}
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        All Media Items
        <Typography
          variant="body2"
          component="span"
          sx={{ ml: 2, color: "text.secondary" }}
        >
          ({data?.totalItems || 0} total • Page {data?.currentPage || 1} of{" "}
          {data?.totalPages || 1})
        </Typography>
      </Typography>

      <Grid container spacing={3}>
        {mediaList.map((item) => {
          const isImage = item.mime_type.startsWith("image/");
          const formattedDate = new Date(item.createdOn).toLocaleDateString(
            "en-IN",
            {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            }
          );

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={item._id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                {/* Media Preview */}
                <CardMedia
                  component={isImage ? "img" : "video"}
                  {...(isImage
                    ? {
                        image: item.preview_url,
                        alt: item.file_name,
                      }
                    : {
                        src: item.preview_url,
                        controls: true,
                      })}
                  sx={{
                    height: 240,
                    objectFit: "cover",
                    backgroundColor: "#f5f5f5",
                  }}
                />

                {/* Content */}
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    noWrap
                    title={item.file_name}
                    gutterBottom
                  >
                    {item.file_name}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Customer: <strong>{item.customerId}</strong>
                  </Typography>

                  {item.email && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      Email: {item.email}
                    </Typography>
                  )}

                  {item.role && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      Role: {item.role}
                    </Typography>
                  )}

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Uploaded: {formattedDate}
                  </Typography>

                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                  >
                    Media ID: {item.mediaId}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {mediaList.length === 0 && (
        <Alert severity="info" sx={{ mt: 4 }}>
          No media items found.
        </Alert>
      )}
    </Container>
  );
};

export default MediaItems;
